// ── ChargeOffForm ──
import { Btn, FInput, FInputNum, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { NotesPanel } from "../components/NotesPanel";
import { useApp } from "../../../shared/appContext";

export const ChargeOffForm = ({ initial, loanid, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const [f, set] = useFreshForm(initial||{ loanid, asofdate:"", amount:"", status:"Forecast" }, "ChargeOffs");
    return <Modal title={readOnly?"View Charge-Off":initial?"Edit Charge-Off":"Add Charge-Off"} onClose={closeModal}
      onEdit={readOnly&&role.canEdit?()=>{ closeModal(); setModal({type:"chargeoff-edit",rec:initial,loanid,onDone:modal.onDone}); }:null}>
      <ReadOnlyForm readOnly={readOnly}>
        <Field label="As-of Date"><FInput value={f.asofdate?.slice(0,10)||""} onChange={set("asofdate")} type="date" /></Field>
        <Field label="Amount"><FInputNum value={f.amount} onChange={set("amount")} /></Field>
        <Field label="Status"><FSelect value={f.status} onChange={set("status")} options={["Forecast","Actual"]} /></Field>
        </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      {initial?.id && <NotesPanel scope="record" entitytype="ChargeOff" entityid={initial.id} accountid={initial.accountid} loanid={loanid} source="Charge-Off" />}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:8 }}>
        <Btn onClick={closeModal}>{readOnly?"Close":"Cancel"}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveChargeOff",{...f,loanid:f.loanid||loanid},initial?"Edited":"Added","ChargeOffs",(initial?"Updated":"Added")+" charge-off",modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
    </Modal>;
  };
